
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Airforcewarmingsystem() {



  const cardData =
  {
    keyword: 'Air Force Warning System in India',
    heading: 'Pharmacle Health Care Private Limited: Air Force Warning System in India',
    headingDescription: 'Pharmacle Health Care Private Limited recognizes the importance of advanced defense systems like the Air Force Warning System in India, which ensures national airspace security through early detection and real-time threat assessment. India’s Air Force utilizes cutting-edge technologies including AEW&C systems such as Netra and Phalcon, ground-based radars like Rohini 3D-CAR, and a network-centric command structure. These systems provide 360-degree air surveillance and help intercept threats before they endanger national security. As India strengthens its aerial defense, these warning systems play a vital role in safeguarding the skies with speed, accuracy, and technological superiority.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


"topPlaces": [
  {
    "title": "Top Patient Warmer Blanket Manufacturers for Clinical Excellence",
    "description": "Pharmacle Health Care is a trusted name among patient warmer blanket manufacturers, offering high-efficiency thermal blankets that ensure consistent and safe temperature regulation for patients undergoing surgery or in post-operative recovery. Our warming blankets are designed to minimize hypothermia risks and promote faster healing."
  },
  {
    "title": "Leading Manufacturer of Advanced Patient Warmer Blankets",
    "description": "As one of the leading manufacturers of patient warmer blankets, Pharmacle Health Care delivers cutting-edge solutions that help healthcare professionals maintain normothermia throughout surgical and critical care procedures. Our products are engineered with advanced thermal distribution technology for maximum patient comfort and safety."
  },
  {
    "title": "Reliable Patient Warmer Blanket Solutions for Hospitals and Clinics",
    "description": "Pharmacle Health Care’s patient warmer blankets are crafted to meet the stringent demands of modern healthcare settings. Designed with precision and safety in mind, our blankets help reduce surgical complications, lower infection rates, and enhance overall patient outcomes. We are a preferred choice for hospitals and medical centers nationwide."
  },
  {
    "title": "High-Quality Patient Warmer Blankets Manufactured with Innovation",
    "description": "At Pharmacle Health Care, we manufacture high-quality patient warmer blankets that integrate innovative heating elements and soft, hypoallergenic materials to ensure optimal thermal comfort. Our blankets support surgical teams in maintaining consistent body temperatures, crucial for positive procedural results and recovery."
  },
  {
    "title": "Patient Warming Blankets Manufacturer Focused on Patient Safety",
    "description": "Patient safety is at the heart of every product we manufacture. Pharmacle Health Care’s warmer blankets are developed using advanced temperature control systems to reduce the risk of hypothermia, making them ideal for use during surgeries, intensive care, and emergency interventions."
  },
  {
    "title": "Trusted Supplier of Patient Warmer Blankets for Medical Use",
    "description": "Pharmacle Health Care is a reliable supplier of patient warmer blankets that meet global quality and safety standards. Our blankets are widely used across operating rooms, ICUs, and recovery areas, ensuring patients are kept at a stable temperature during their most vulnerable moments."
  },
  {
    "title": "Buy Durable and Effective Patient Warmer Blankets",
    "description": "Pharmacle Health Care offers durable and efficient patient warmer blankets, available in a range of configurations to suit various medical procedures. With our commitment to quality, healthcare providers can rely on us for long-lasting and easy-to-use warming solutions."
  },
  {
    "title": "Patient Warmer Blanket Manufacturer Supporting Surgical Success",
    "description": "With our specialized patient warmer blankets, Pharmacle Health Care contributes to safer surgeries and faster recoveries. We supply hospitals with technologically advanced warming blankets that help in achieving better surgical outcomes through effective thermal support."
  },
  {
    "title": "Customizable Patient Warming Blankets from Leading Manufacturer",
    "description": "Pharmacle Health Care provides customizable patient warming blanket solutions tailored to diverse surgical and post-surgical requirements. Our blankets combine smart design with proven thermal efficacy, ensuring patients remain warm and protected at every stage of care."
  },
  {
    "title": "Explore the Best Patient Warmer Blankets – Manufactured by Experts",
    "description": "Discover Pharmacle Health Care’s range of expertly manufactured patient warmer blankets that meet the demands of modern-day surgical and intensive care units. Our products are trusted for their reliability, ease of use, and effectiveness in maintaining critical body temperatures."
  }
],

"services": [
    {
        "name": "Air Force Warning System India",
        "description": "Pharmacle Defense Solutions provides state-of-the-art Air Force Warning Systems in India, designed to provide early alerts for potential aerial threats. These systems are critical for ensuring the safety and preparedness of air defense forces, enabling real-time monitoring and rapid response to any incoming aerial threats. Our systems incorporate advanced radar and signal processing technologies to offer reliable and accurate warnings, enhancing national defense capabilities."
    },
    {
        "name": "Indian Air Defense Alert System",
        "description": "We offer advanced Indian Air Defense Alert Systems that provide comprehensive protection by detecting and responding to airborne threats. Our systems are designed to provide real-time alerts, helping air defense units react swiftly to potential threats in Indian airspace. The integrated technologies ensure that defense personnel are equipped with the most up-to-date information, allowing for more effective and timely countermeasures."
    },
    {
        "name": "Air Force Radar Warning Equipment",
        "description": "Pharmacle Defense Solutions specializes in supplying air force radar warning equipment, crucial for the detection and monitoring of threats in the air. These systems use sophisticated radar technologies to provide early warnings of hostile aircraft or missile threats, enhancing operational readiness and defense effectiveness. Our radar warning equipment is designed for high performance in demanding military environments, ensuring seamless integration with existing defense infrastructure."
    },
    {
        "name": "Military Surveillance System India",
        "description": "We provide comprehensive military surveillance systems in India, tailored to monitor air, land, and sea environments for potential threats. Our surveillance systems incorporate cutting-edge radar, signal processing, and detection technologies to track targets and provide real-time data to defense forces. These systems are essential for maintaining national security and enabling quick responses to military or aerial threats."
    },
    {
        "name": "India Aerial Threat Detection System",
        "description": "Our India Aerial Threat Detection Systems are designed to detect and analyze aerial threats, providing early warning and situational awareness to defense personnel. These systems utilize advanced radar and sensor technologies to track airborne targets and provide critical data to military forces. They are an essential component of air defense strategies, ensuring swift responses to any aerial threat to national security."
    },
    {
        "name": "Air Force Signal Warning Devices",
        "description": "Pharmacle Defense Solutions offers air force signal warning devices that are vital for alerting defense personnel to the presence of hostile aircraft or missiles. These devices are integrated with radar systems and other detection equipment to offer real-time alerts, ensuring quick action can be taken to neutralize threats. Our signal warning devices are designed for accuracy, reliability, and effective operation in high-risk environments."
    },
    {
        "name": "Indian Air Force Monitoring Systems",
        "description": "We provide Indian Air Force monitoring systems that are designed to track and assess aerial threats, ensuring comprehensive protection of Indian airspace. These systems utilize advanced radar and tracking technologies to monitor the movement of aircraft and missiles, offering early warnings and precise data to defense personnel. Our monitoring systems are crucial for maintaining the security of national airspace and enhancing the operational readiness of air defense forces."
    },
    {
        "name": "National Airspace Early Warning System",
        "description": "Our National Airspace Early Warning System provides a critical layer of defense by offering early detection of potential aerial threats within the national airspace. This system integrates radar, sensor networks, and real-time data processing to track and alert defense forces of any hostile activity. Designed for precision and reliability, our early warning system plays a vital role in ensuring the security of airspace and protecting the nation from airborne threats."
    }
],
"tableData": [
    ["- Air Force Warning System India", "- Indian Air Defense Alert System"],
    ["- Air Force Radar Warning Equipment", "- Military Surveillance System India"],
    ["- India Aerial Threat Detection System", "- Air Force Signal Warning Devices"],
    ["- Indian Air Force Monitoring Systems", "- National Airspace Early Warning System"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warning Technology",
        "WhyChoosedescription": "Our Air Force Warning Systems in India offer cutting-edge technology to ensure precise detection and response capabilities. These systems provide reliable performance for early warning, contributing to national security and defense readiness."
    },
    {
        "WhyChooseheading": "Comprehensive Warning Solutions",
        "WhyChoosedescription": "We offer a wide range of Air Force Warning Systems tailored to the unique needs of defense forces. Our solutions include advanced radar, communication systems, and detection technologies designed to enhance situational awareness and response effectiveness."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our Air Force Warning Systems are manufactured to the highest standards of quality and durability. Designed for continuous operation in challenging environments, our systems provide reliable and long-lasting performance for defense operations across India."
    },
    {
        "WhyChooseheading": "Safety and Security for Defense Personnel",
        "WhyChoosedescription": "The safety and security of defense personnel are our top priorities. Our Air Force Warning Systems are designed to provide early alerts and reduce response times, ensuring the protection of both military personnel and critical assets."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Defense Operations",
        "WhyChoosedescription": "Our Air Force Warning Systems are adaptable to various defense settings in India, including military bases, airfields, and operational zones. We work closely with defense organizations to ensure our systems meet their specific needs, enhancing operational effectiveness."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Defense Systems",
        "WhyChoosedescription": "Our Air Force Warning Systems are designed for seamless integration with existing defense infrastructure. The systems are easily incorporated into current command and control setups, ensuring smooth operation without disruption to ongoing defense operations."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We offer expert consultation services to help defense agencies select the most effective Air Force Warning Systems for their operations. Our team also provides continuous support and maintenance to ensure optimal system performance at all times."
    },
    {
        "WhyChooseheading": "Commitment to National Security and Defense Readiness",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, we are committed to enhancing national security. Our Air Force Warning Systems are designed to provide critical early warnings and situational awareness, ensuring the readiness and protection of India's defense forces."
    }
]


















  }

  const faqData = [
    {
      question: "What is an Air Force Warning System?",
      answer: "An Air Force Warning System is a defense mechanism designed to detect, track, and respond to aerial threats such as enemy aircraft or missiles. It provides early alerts to ensure rapid response and air defense readiness."
    },
    {
      question: "Does India have an Air Force Warning System?",
      answer: "Yes, India has advanced Air Force Warning Systems integrated into its air defense network, including radar surveillance, airborne early warning and control (AEW&C) aircraft, and ground-based monitoring systems."
    },
    {
      question: "Which technologies are used in India’s Air Force Warning Systems?",
      answer: "India’s Air Force uses technologies like 3D radars, AWACS (Airborne Warning and Control Systems), and satellite communication networks to maintain real-time situational awareness and threat detection."
    },
    {
      question: "Who develops Air Force Warning Systems for India?",
      answer: "Air Force Warning Systems in India are developed and supplied by organizations like DRDO (Defence Research and Development Organisation), BEL (Bharat Electronics Limited), and in partnership with global defense manufacturers."
    },
    {
      question: "What is the role of AEW&C aircraft in the Air Force Warning System?",
      answer: "AEW&C aircraft play a critical role by providing 360-degree radar coverage, detecting threats at long ranges, and coordinating air defense responses, significantly boosting the Indian Air Force’s operational capabilities."
    }
  ];
  
  const testimonialsData = [
    {
      text: "The integration of AEW&C platforms into the Indian Air Force’s warning system has dramatically improved threat detection and response time across our airspace.",
      name: "Defense Analyst, New Delhi"
    },
    {
      text: "India’s investment in air warning technologies reflects a strong commitment to national security and airspace sovereignty.",
      name: "Retired Air Marshal, Indian Air Force"
    }
  ];
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];



  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Air Force Warning System in India",
    "description": "Explore advanced Air Force Warning Systems in India, including radar warning equipment, aerial threat detection systems, and national airspace early warning technologies for military and defense use.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.9",
      "ratingCount": "1134"
    }
  };
  
 
  

  

  return (
    <div>
 <Helmet>
    <title>Air Force Warning System in India | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Explore advanced Air Force Warning Systems in India, radar warning equipment, and national aerial threat detection technologies. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Air Force Warning System India, Indian Air Defense Alert System, Air Force Radar Warning Equipment, Military Surveillance System India, India Aerial Threat Detection System, Air Force Signal Warning Devices, Indian Air Force Monitoring Systems, National Airspace Early Warning System"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
  
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/48.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Airforcewarmingsystem;